import React from 'react';

const SvgReport = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M22 3H1v2h1v13h9v3h2v-3h9V5h1V3h-1zm-4.457 8.957L15 9.414l-4 4-2-2-2.543 2.543-1.414-1.414L9 8.586l2 2 4-4 3.957 3.957-1.414 1.414z" />
  </svg>
);

export default SvgReport;
